import { ApiCall } from "common/types/api";
import { Preferences } from "common/types/preferences";

export const preferencesApi = (apiCall: ApiCall) => ({
  set: (value: Preferences) => apiCall("put", `/api/ui/preferences`, value),
  get: () => apiCall<Preferences>("get", `/api/ui/preferences`),
});
